
<f-dialog
    :title        = "$t('msd.operator.assign')"
    v-model       = "value"
    :width        = "500"
    :show-header  = "false"
    :hide-actions = "true"
>
    <template v-slot:content>
        <v-form ref="form" style="position: relative">
            <div style="position: absolute; right: 0" class="pt-1">
                <a  @click="onCancel" >
                    <v-icon
                        color = "primary"
                        size  = "26"
                    >
                        mdi-close
                    </v-icon>
                </a>
            </div>
            <v-tabs
                v-model = "tabs"
                height="35"
                class   = "folder-tabs ml-0 mt-2"
                active-class = "folder-tab-active primary"
                left
                style="border-bottom-style: solid; border-width: 1px; border-bottom-color: lightgray"
            >
                <v-tabs-slider color="primary"></v-tabs-slider>
                <v-tab class="folder-tab">
                    Kunde
                </v-tab>
                <v-tab class="folder-tab">
                    Verwalter
                </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabs" class="mt-1">
                <v-tab-item>
                    <company-edit
                        v-if="company"
                        class         = "mb-3"
                        :height       = "439"
                        :company      = "company"
                        :comment-rows = "10"
                        @stored       = "onStored"
                    >
                        <template v-slot:additional>
                            <v-row class="no-frame">
                                <v-col class="no-frame">
                                    <v-text-field
                                        label          = "Import Name"
                                        v-model        = "company.idname"
                                        autocomplete   = "off"
                                        autocorrect    = "off"
                                        autocapitalize = "off"
                                        spellcheck     = "false"
                                    />
                                </v-col>
                            </v-row>
                        </template>
                    </company-edit>
                </v-tab-item>
                <v-tab-item>
                    <div>
                        <v-text-field
                            hide-details
                            class          = "mt-0 pt-5 mb-3"
                            @input         = "onInput"
                            append-icon    = "fas fa-search"
                            v-model        = "search"
                            :label         = "$t('msd.operator.input')"
                            :clearable     = "true"
                            autocomplete   = "off"
                            autocorrect    = "off"
                            autocapitalize = "off"
                            spellcheck     = "false"
                        />
                    </div>

                    <v-container class = "seletable-content pa-0">
                        <company-card
                            v-for       = "(item,index) in selectable"
                            :company    = "item"
                            :key        = "index"
                            :background = "background(item)"
                            class       = "mt-0 mb-2 w-100"
                            @click      = "onCompany(item)"
                        />
                    </v-container>
                </v-tab-item>
            </v-tabs-items>
        </v-form>
    </template>
</f-dialog>
